import { faLock, faTableColumns } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Badge, Button, IconButton, useMediaQuery, useTheme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Tooltip } from '@scoir/tooltips'

export default function ColumnManagement({
  enabled,
  onOpenColumnsManagement,
}: {
  enabled: boolean
  onOpenColumnsManagement?: () => void
}) {
  return !enabled ? (
    <Badge
      color="secondary"
      badgeContent={<FontAwesomeIcon icon={faLock} />}
    >
      <ResponsiveColumnsButton disabled />
    </Badge>
  ) : (
    <ResponsiveColumnsButton onOpenColumnsManagement={onOpenColumnsManagement} />
  )
}

const useStyles = makeStyles((theme) => ({
  iconButton: {
    '&.MuiIconButton-root.Mui-disabled': {
      color: theme.palette.primary.main,
      opacity: 0.3,
    },
  },
}))
type ResponsiveColumnsButtonProps = {
  onOpenColumnsManagement?: () => void
  disabled?: boolean
}
const ResponsiveColumnsButton = ({ onOpenColumnsManagement, disabled }: ResponsiveColumnsButtonProps) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMediumScreenSize = useMediaQuery(theme.breakpoints.down('md'))
  return isMediumScreenSize ? (
    <Tooltip title="Columns">
      <IconButton
        color="primary"
        className={classes.iconButton}
        disabled={disabled}
        onClick={() => onOpenColumnsManagement?.()}
      >
        <FontAwesomeIcon icon={faTableColumns} />
      </IconButton>
    </Tooltip>
  ) : (
    <Button
      color="primary"
      variant="text"
      disabled={disabled}
      startIcon={<FontAwesomeIcon icon={faTableColumns} />}
      onClick={() => onOpenColumnsManagement?.()}
    >
      Columns
    </Button>
  )
}
